'use client';
const EMPTY_ANCHOR_ATTR = {};
const useHeaderBrandLogo = brandLogo => {
  const logoIsSeperated = Array.isArray(brandLogo);
  if (logoIsSeperated) {
    const [nLogo = EMPTY_ANCHOR_ATTR, payLogo = EMPTY_ANCHOR_ATTR] = brandLogo;
    return {
      nLogo,
      payLogo
    };
  }
  return {
    npayLogo: brandLogo
  };
};

export { useHeaderBrandLogo as default };
